import { Link, useLocation } from 'react-router-dom';

const EmailsSectionTabs = () => {
  const location = useLocation();
  const isPerformance = location.pathname.includes('/email-performance');

  return (
    <div className='flex-centered mr-3'>
      <Link
        to='/people/emails'
        className={`general-button rounded-pill nowrap-item text-decoration-none  px-3 mr-3 specific-y-padding-7 ${!isPerformance ? 'bg-light-blue text-white' : 'border-general border-light-blue text-light-blue hovered-button link-hover'}`}
      >
        Send emails
      </Link>
      <Link
        to='/people/email-performance'
        className={`general-button rounded-pill nowrap-item text-decoration-none px-3 specific-y-padding-7 ${isPerformance ? 'bg-light-blue text-white' : 'border-general border-light-blue text-light-blue hovered-button link-hover'}`}
      >
        Email performance
      </Link>
    </div>
  );
};

export default EmailsSectionTabs;
